/**
 * @file
 * A JavaScript file for the theme.
 *
 * In order for this JavaScript to be loaded on pages, see the instructions in
 * the README.txt next to this file.
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth
(function ($, Drupal, once) {
  // To understand behaviors, see https://drupal.org/node/756722#behaviors
  Drupal.behaviors.mobileMenu = {
    attach: function (context, settings) {
      /**
       * Mobile hamburger menu
       * @return {[type]} [description]
       */
      $(once("mobileMenu", "html", context))
      .each(function () {
          // mobile menu navigation forward link
          //console.log('mobile menu is running');
          Array.from(
            document.getElementsByClassName("menu_level_forward")
          ).forEach(function (element) {
            element.addEventListener("click", function (e) {
              // get next sibling of menu navigation link
              let selectedSubMenu = element.nextElementSibling;

              if (selectedSubMenu.matches(".subnav-main__submenu ")) {
                // add active state for next level of menu on click
                selectedSubMenu.classList.add("submenu-active");

                // save selectedSubMenu to currentMenu var to traverse up DOM
                let currentMenu = selectedSubMenu;

                // add disabled state on parent menus
                while (
                  (currentMenu = currentMenu.parentNode.closest(".menu__main"))
                ) {
                  currentMenu.classList.add("not-active");
                }
              }

              e.preventDefault();
            });
          });

          // mobile menu navigation back link
          Array.from(
            document.getElementsByClassName("menu_level_back")
          ).forEach(function (element) {
            element.addEventListener("click", function (e) {
              // get submenu element
              let currentSubMenu = element.closest(".submenu-active");

              // remove active state for current submenu
              currentSubMenu.classList.remove("submenu-active");

              // get current submenu parent
              let currentParent = currentSubMenu.closest(".not-active");

              // remove disabled state from parent menu
              if (currentParent != null) {
                currentParent.classList.remove("not-active");
              }

              e.preventDefault();
            });
          });
        });
    },
  };
})(jQuery, Drupal, once);
